/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IDropdownStyles } from '@fluentui/react/lib/Dropdown';
import { ILabelStyles } from '@fluentui/react/lib/Label';
import { IStackStyles } from '@fluentui/react/lib/Stack';
import { ITheme } from '@fluentui/react/lib/Styling';
import { FontSizes } from '../../../../../styles/teams';

export const getStackStyles = (theme: ITheme): Partial<IStackStyles> => {
    return {
        root: {
            height: '100%',
            selectors: {
                '.approvers-people-picker': {
                    maxWidth: '37.5rem',
                    marginTop: '0.625rem',
                    marginBottom: '1.25rem',
                },
                '.template-instance-fields .ms-Label:not(.inner-error-label)': {
                    fontSize: FontSizes.size14,
                    color: theme.palette.black + ' !important',
                    fontWeight: 'bold',
                },
                '.template-instance-fields > div': {
                    marginBottom: '1.25rem',
                },
                '.template-instance-fields .ms-TextField': {
                    maxWidth: '37.5rem',
                },
            },
        },
    };
};

export const getLabelStyles = (): Partial<ILabelStyles> => {
    return {
        root: {
            marginBottom: '0.5rem',
        },
    };
};

export const getDropdownStyles = (): Partial<IDropdownStyles> => {
    return { root: { width: '18.5rem' } };
};
